import { render, staticRenderFns } from "./Learn_more.vue?vue&type=template&id=af7b4ce0"
import script from "./Learn_more.vue?vue&type=script&lang=js"
export * from "./Learn_more.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports